import React from "react";

import { COLORS } from "@tSurya/theme/design.mgbw";

const MGBWMenuIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M18.75 9.3125H1.25C0.875 9.3125 0.53125 9.625 0.53125 10.0312C0.53125 10.4062 0.84375 10.75 1.25 10.75H18.75C19.125 10.75 19.4687 10.4375 19.4687 10.0312C19.4687 9.625 19.125 9.3125 18.75 9.3125Z" fill={COLORS.primary.base}/>
            <path d="M18.75 14.625H1.25C0.875 14.625 0.53125 14.9375 0.53125 15.3437C0.53125 15.75 0.84375 16.0625 1.25 16.0625H18.75C19.125 16.0625 19.4687 15.75 19.4687 15.3437C19.4687 14.9375 19.125 14.625 18.75 14.625Z" fill={COLORS.primary.base}/>
            <path d="M1.25 5.375H18.75C19.125 5.375 19.4687 5.0625 19.4687 4.65625C19.4687 4.25 19.1562 3.9375 18.75 3.9375H1.25C0.875 3.9375 0.53125 4.25 0.53125 4.65625C0.53125 5.0625 0.875 5.375 1.25 5.375Z" fill={COLORS.primary.base}/>
        </svg>
    );
};

export default React.memo(MGBWMenuIcon);